import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.js'
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import AppRoutes from './Routes';
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                {/*<AppRoutes />*/}
                <App/>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>

);
reportWebVitals();